<template>
  <OldDataTable :loading="loading" :rows="filteredItems" :cols-map="colsMap">
    <template #row="{sortedRows}">
      <TableRow v-for="item in sortedRows" :key="item.name">
        <td v-for="(col, _, index) in colsMap" :key="col">
          <div class="d-flex justify-content-between">
            <div v-if="isCheckboxEntry(item[col])">
              <span
                v-if="isCellLoading(item.id, col)"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
              <BootstrapCheck
                v-else
                :id="`old-table-checkbox-${index}`"
                :model-value="item[col]"
                :scale="1"
                :disabled="cellLoading"
                @update:model-value="(value: boolean) => $emit('checked', item.id, col, value)"
              />
            </div>
            <div v-else>{{ item[col] }}</div>
            <ProductIconButtonGroup
              v-if="index === colsMapLength - 1"
              @delete="$emit('delete', item.id)"
              @update="$emit('update', item.id)"
            />
          </div>
        </td>
      </TableRow>
    </template>
  </OldDataTable>
</template>
<script setup lang="ts">
interface Props {
  loading?: boolean;
  loadingRowId?: number;
  loadingColKey?: string;
  searchValue?: string;
  items: any[];
  colsMap: {[key: string]: string};
}

const props = withDefaults(defineProps<Props>(), {
  loading: false,
  loadingRowId: undefined,
  loadingColKey: undefined,
  searchValue: '',
  items: () => [],
});

defineEmits<{
  checked: [id: number, key: string, value: boolean];
  delete: [id: number];
  update: [id: number];
}>();

const colsMapLength = computed(() => Object.keys(props.colsMap).length);

const filteredItems = computed(() => {
  if (!props.searchValue) {
    return props.items;
  }
  return props.items.filter((item) => {
    return item.name.toLowerCase().includes(props.searchValue.toLowerCase());
  });
});

const isCellLoading = (id: number, col: string) =>
  id === props.loadingRowId && col === props.loadingColKey;

const cellLoading = computed(() => (props.loadingRowId && props.loadingColKey ? true : false));

const isCheckboxEntry = (value: string | boolean) => typeof value === 'boolean';
</script>
